const validations = {
  violate_date: {
    required: true
  },
  submitted_by: {
    required: true
  },
  event: {
    required: true
  },
  resolution: {
    required: true
  },
  assignDate: {
    required: true
  },
  staffId: {
    required: true
  }
};
export { validations };
